import React, { useState, useEffect } from "react";
import { Formik, Field, ErrorMessage, Form } from "formik";
import * as Yup from "yup";
import awsService from "../services/awsService";
import { useStateContext } from "../contexts/ContextProvider";
import { FaEdit, FaTrashAlt } from "react-icons/fa";
import { GiCancel } from "react-icons/gi";
import { ToastContainer, toast } from "react-toastify";
import DeleteConfirmationModal from "../components/DeleteConfirmationModal";
import { TooltipComponent } from "@syncfusion/ej2-react-popups";
import { Row, Col, Button, Alert, Modal } from "react-bootstrap";
import { load } from "@syncfusion/ej2-react-grids";
import Loading from "../components/Loading";
import AddAwsAccount from "../components/AWSManage/AddAwsAccount";

const initialValues = {
  accountName: "",
  accessKey: "",
  secretKey: "",
};

const validationSchema = Yup.object({
  accountName: Yup.string().required("Account Name is required"),
  accessKey: Yup.string()
    .required("Access Key is required")
    .min(10, "Too Short!")
    .max(50, "Too Long!"),
  secretKey: Yup.string()
    .required("Secret Key is required")
    .min(10, "Too Short!")
    .max(50, "Too Long!"),
});

const AwsManage = () => {
  const [aws, setAws] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [deleteModal, setDeleteModal] = useState(false);
  const [itemToDelete, setItemDelete] = useState(null);
  const { currentColor } = useStateContext();
  const { currentMode } = useStateContext();
  const [searchValue, setSearchValue] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSearchChange = (e) => {};

  useEffect(() => {
    fetchAws();
  }, []);

  const fetchAws = async () => {
    try {
      const userlimit = {};
      const data = await awsService.getawss(userlimit);
      setAws(data);
    } catch (error) {
      console.error("Error fetching AWS:", error);
    }
  };

  const handleEdit = (user) => {
    setSelectedUser(user);
    setShowModal(true);
  };

  const handleDelete = async () => {
    try {
      setLoading(true);
      const deletedAcc = await awsService.deleteaws(itemToDelete);
      if (deletedAcc.success) {
        setLoading(false);
        toast.success("Deleted successfully", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else {
        setLoading(false);

        toast.error(deletedAcc.message || "Failed to delete", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
      fetchAws();
      setItemDelete(null);
    } catch (error) {
      setLoading(false);
      toast.error("Error Deleting AWS Account", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  const handleFormSubmit = async (values, { setSubmitting }) => {
    try {
      setLoading(true);
      setShowModal(false);
      console.log("sub");
      if (selectedUser !== null) {
        await awsService.updateaws(selectedUser._id, values);
      } else {
        await awsService.addaws(values);
      }
      setSubmitting(false);
      setShowModal(false);
      setLoading(false);
      fetchAws();
    } catch (error) {
      console.error("Error submitting form:", error.response.data.message);
      setLoading(false);
      toast.error(
        `${error.response.data.message}` || "Error creating Account",
        {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        }
      );
      setSubmitting(false);
    }
  };

  const getInitialValues = () => {
    if (selectedUser) {
      return {
        accountName: selectedUser.accountName || "",
        secretKey: selectedUser.secretKey || "",
        accessKey: selectedUser.accessKey || "",
      };
    }
    return initialValues;
  };

  const handleDeleteModal = (id) => {
    setItemDelete(id);
    setDeleteModal(true);
  };

  const handleClose = () => {
    setItemDelete(null);
    setDeleteModal(false);
  };

  const handleModalClose = () => {
    setShowModal(false);
  };

  return (
    <>
      {" "}
      <div className="p-2">
        {/* Search and Filter Bar */}
        <div className="flex justify-end space-x-2 ">
          <input
            type="text"
            className={`px-2 py-1 transition-colors duration-300 ${
              currentMode === "Dark"
                ? "text-white bg-[#33373E] hover:bg-[#444950]"
                : "bg-white border hover:border-gray-400"
            }`}
            placeholder="Search..."
            value={searchValue}
            onChange={handleSearchChange}
          />

          {/* <input
        type="text"
        className={`px-2 py-1  ${
          currentMode === "Dark"
            ? "text-white bg-[#33373E]"
            : "bg-white border"
        }`}
        placeholder="Filter..."
        value={searchValue}
        onChange={handleSearchChange}
      /> */}
          <TooltipComponent content="Add Client" position="BottomRight">
            {" "}
            <button
              className="ml-auto flex items-center justify-center px-2 py-2 bg-blue-500 text-white rounded-full hover:bg-blue-600"
              onClick={() => {
                setSelectedUser(null);
                setShowModal(true);
              }}
              style={{ backgroundColor: currentColor }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                />
              </svg>
            </button>
          </TooltipComponent>
        </div>
      </div>
      <hr className="border-gray-500 border-1 p-0 m-0" />
      <div className=" mx-8 my-4 p-2 ">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-3 gap-4 ">
          {aws.map((user) => (
            // <div
            //   key={user._id}
            //   className={` shadow-md cursor-pointer ${
            //     currentMode === "Dark" ? "text-white bg-[#33373E]" : "bg-white"
            //   }`}
            //   // style={{
            //   //   height: "150px",
            //   //   display: "flex",
            //   //   flexDirection: "column",
            //   //   justifyContent: "space-between",
            //   // }}
            // >
            //   <div className="flex items-center p-0 shadow">
            //     <div
            //       className="w-16 h-32  rounded-r-full"
            //       style={{
            //         backgroundColor: currentColor,
            //         // height: "105px",
            //         // width: "65px",
            //         // borderRadius: "0 100% 100% 0/0 50% 50% 0",

            //         // left: "-24px",
            //       }}
            //     >
            //       <span
            //               style={{
            //                 mask: `url(/icons/file-icon-1.svg) center no-repeat`,
            //                 WebkitMask: `url(/icons/file-icon-1.svg) center no-repeat`,
            //                 maskSize: "contain",
            //                 WebkitMaskSize: "contain",
            //                 display: "block",
            //                 width: "45px",
            //                 height: "45px",
            //                 backgroundColor: "white",
            //                 transition: "background-color 0.3s",
            //               }}
            //             ></span>
            //     </div>
            //     <div className="w-3/4 pl-4">
            //       <p
            //         className="text-lg break-words"

            //       >
            //         {user.accountName}
            //       </p>
            //     </div>
            //   </div>

            //   <div className="flex space-x-2 mt-4 justify-end">
            //     <TooltipComponent content="Edit" position="BottomCenter" style={{ top: "-45px"}}>
            //       <button
            //         className="px-2 py-2 text-white rounded-lg transition duration-300 ease-in-out hover:bg-gray-700 relative"
            //         style={{ backgroundColor: currentColor, top: "-45px" }}
            //         onClick={() => handleEdit(user)}
            //       >
            //         <span
            //           style={{
            //             mask: `url(/icons/edit-icon.svg) center no-repeat`,
            //             WebkitMask: `url(/icons/edit-icon.svg) center no-repeat`,
            //             maskSize: "contain",
            //             WebkitMaskSize: "contain",
            //             display: "block",
            //             width: "15px",
            //             height: "15px",
            //             backgroundColor: "white",
            //             transition: "background-color 0.3s",
            //           }}
            //         ></span>
            //       </button>
            //     </TooltipComponent>
            //     <TooltipComponent content="Delete" position="BottomCenter">
            //       <button
            //         className="px-2 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600 relative"
            //         onClick={() => handleDeleteModal(user._id)}
            //         style={{ backgroundColor: currentColor, top: "-45px" }}
            //       >
            //         <span
            //           style={{
            //             mask: `url(/icons/delete-icon.svg) center no-repeat`,
            //             WebkitMask: `url(/icons/delete-icon.svg) center no-repeat`,
            //             maskSize: "contain",
            //             WebkitMaskSize: "contain",
            //             display: "block",
            //             width: "15px",
            //             height: "15px",
            //             backgroundColor: "white",
            //             transition: "background-color 0.3s",
            //           }}
            //         ></span>
            //       </button>
            //     </TooltipComponent>
            //   </div>
            // </div>

            <div className="flex items-center p-0 bg-white shadow">
              <div
                className="h-32  rounded-r-full"
                style={{ backgroundColor: currentColor,width:"6rem"}}
              >
                <span
                  style={{
                    mask: `url(/icons/file-icon-1.svg) center no-repeat`,
                    WebkitMask: `url(/icons/file-icon-1.svg) center no-repeat`,
                    maskSize: "contain",
                    WebkitMaskSize: "contain",
                    display: "block",
                    width: "45px",
                    height: "45px",
                    backgroundColor: "white",
                    transition: "background-color 0.3s",
                    marginTop: "40px",
                    marginLeft: "2px",
                  }}
                ></span>
              </div>
              <div className="w-3/4 pl-4 ">
                <h3 className="text-lg break-words">{user.accountName}</h3>
              </div>
              <div className="flex justify-end">
                <TooltipComponent
                  content="Edit"
                  position="BottomCenter"
                  
                >
                  <button
                    className="px-2 py-2 text-white rounded-lg transition duration-300 ease-in-out hover:bg-gray-700 relative top-10 mr-2"
                    style={{ backgroundColor: currentColor,}}
                    onClick={() => handleEdit(user)}
                  >
                    <span
                      style={{
                        mask: `url(/icons/edit-icon.svg) center no-repeat`,
                        WebkitMask: `url(/icons/edit-icon.svg) center no-repeat`,
                        maskSize: "contain",
                        WebkitMaskSize: "contain",
                        display: "block",
                        width: "15px",
                        height: "15px",
                        backgroundColor: "white",
                        transition: "background-color 0.3s",
                      }}
                    ></span>
                  </button>
                </TooltipComponent>
                <TooltipComponent content="Delete" position="BottomCenter">
                  <button
                    className="px-2 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600 relative  top-10 mr-2"
                    onClick={() => handleDeleteModal(user._id)}
                    style={{ backgroundColor: currentColor,  }}
                  >
                    <span
                      style={{
                        mask: `url(/icons/delete-icon.svg) center no-repeat`,
                        WebkitMask: `url(/icons/delete-icon.svg) center no-repeat`,
                        maskSize: "contain",
                        WebkitMaskSize: "contain",
                        display: "block",
                        width: "15px",
                        height: "15px",
                        backgroundColor: "white",
                        transition: "background-color 0.3s",
                      }}
                    ></span>
                  </button>
                </TooltipComponent>
              </div>
            </div>
          ))}
        </div>

        <AddAwsAccount
          showForm={showModal}
          closeModel={handleModalClose}
          getInitialValues={getInitialValues}
          validationSchema={validationSchema}
          handleFormSubmit={handleFormSubmit}
          selectedAccount={selectedUser}
        />

        {loading && <Loading loading={"loading"} currentColor={currentColor} />}
        <ToastContainer />

        {deleteModal && (
          <DeleteConfirmationModal
            onClose={handleClose}
            onDelete={handleDelete}
          />
        )}
      </div>
    </>
  );
};

export default AwsManage;
